import { render, staticRenderFns } from "./billSetting.vue?vue&type=template&id=da668faa&"
import script from "./billSetting.vue?vue&type=script&lang=js&"
export * from "./billSetting.vue?vue&type=script&lang=js&"
import style0 from "./billSetting.vue?vue&type=style&index=0&id=da668faa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports